import { applyAceDesign } from './ace-design.js';
import './ace-design.css';
import { GalleryError, resolveApiBaseUrl } from './api.js';

// Admin-owned code registry. Customer content never becomes HTML or executable templates.
const designs = {
  'ace-archery-2010': applyAceDesign,
  'miu-classic': (site, landing) => {
    document.body.dataset.siteDesign = 'miu-classic';
    document.title = `${site.name} — Khoảnh khắc của bạn`;
    const brand = document.querySelector('.brand');
    brand.href = `/${site.slug}`;
    brand.setAttribute('aria-label', `${site.name} — trang chủ`);
    brand.querySelector('img').hidden = true;
    brand.querySelector('span').textContent = site.name;
    document.querySelectorAll('.state-panel .eyebrow').forEach(el => { el.textContent = site.name; });
    document.querySelector('footer > span').textContent = `© ${new Date().getFullYear()} ${site.name}`;
    document.getElementById('main-photo').alt = `Khoảnh khắc tại ${site.name}`;
    if (!landing) return;
    let panel = document.getElementById('site-landing');
    if (!panel) {
      panel = document.createElement('section');
      panel.id = 'site-landing';
      panel.className = 'site-landing';
      const eyebrow = document.createElement('p');
      eyebrow.className = 'eyebrow';
      eyebrow.textContent = 'CHÀO MỪNG BẠN';
      const title = document.createElement('h1');
      title.textContent = site.name;
      const description = document.createElement('p');
      description.className = 'intro';
      description.textContent = 'Một lần gặp gỡ. Những khoảnh khắc ở lại.';
      const instruction = document.createElement('div');
      instruction.className = 'site-qr-note';
      const heading = document.createElement('h2');
      heading.textContent = 'Mở bộ ảnh của bạn';
      const detail = document.createElement('p');
      detail.textContent = 'Quét mã QR nhận được sau khi chụp để xem và tải ảnh. Mỗi bộ ảnh có đường dẫn riêng.';
      instruction.append(heading, detail);
      panel.append(eyebrow, title, description, instruction);
      document.querySelector('main').append(panel);
    }
    panel.hidden = false;
  }
};

export async function initializeSite(slug, baseUrl, landing, signal) {
  let response;
  try {
    response = await fetch(`${resolveApiBaseUrl(baseUrl)}/api/v3/gallery-sites/${encodeURIComponent(slug)}`, {
      signal, credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store'
    });
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new GalleryError('network_error');
  }
  if (!response.ok) throw new GalleryError(response.status === 404 ? 'gallery_not_found' : 'request_failed');
  const { site } = await response.json();
  if (!site || site.slug !== slug || !designs[site.designKey]) throw new GalleryError('gallery_not_found');
  designs[site.designKey](site, landing);
}
